import { useEffect, useState } from "react";
import useForm from "../hooks/useForm";
import { PaginatingAndSortingProps } from "../components/table-pagination-sorting/interfaces/interfaces";
import { useDoneFetchActions } from "../hooks/useDoneFetchActions";
import { initialPlantas, propsPlantas, tableComponentComplet } from "../utils/formsInitialsStates";
import { getPlantas } from "../services/adminServices";
import { payDriversByDates } from "../services/reportesServices";
import { Table } from "../components/table-pagination-sorting/components/Table";
import { useLocation } from "react-router-dom";
import { PATHS, TABLES_TITLES } from "../utils/Constant";
import { dateToInput } from "../utils/utility";

export const PagoConductores = () => {
  const doneFetchActions = useDoneFetchActions();
  const tipoReporte = useLocation().pathname.split('/')[1];
  const [data, setData] = useState({ count: 0, titles: TABLES_TITLES[tipoReporte] } as tableComponentComplet)
  const [filterData, setDataFilter] = useState({
    fechaIni: dateToInput(),
    fechaFin: dateToInput()
  } as filtersProps);
  interface filtersProps extends PaginatingAndSortingProps {
    fechaFin: string,
    fechaIni: string,
    planta: number
  }
  useEffect(() => {
    doneFetchActions(payDriversByDates(filterData, undefined, tipoReporte))
      .then(data => {
        const titles = [...TABLES_TITLES[tipoReporte]];
        if (tipoReporte === PATHS.REPORTES.ESTRACTO_D_CONDUCTOR) {
          titles.splice(2, 0, ...Object.keys(data?.rows?.[0] || [])
            .filter(key => /^\d{4}-\d{2}-\d{2}$/.test(key))
            .map(name => ({ sort: name, title: name })));
        }
        setData({ ...data, titles });
      });
  }, [filterData, doneFetchActions, tipoReporte])

  const handleChangeTable = (pageAction: PaginatingAndSortingProps) => {
    setDataFilter((dt) => ({ ...dt, ...pageAction }));
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setDataFilter((dt) => ({ ...dt, ...formValues }));
  };

  function downReport(type: string) {
    doneFetchActions(payDriversByDates(filterData, type, tipoReporte))
  }

  const { handleInputChange, formValues } = useForm({
    fechaIni: dateToInput(),
    fechaFin: dateToInput(),
    planta: 0
  });
  const [plantas, setPlantas] = useState([initialPlantas])
  useEffect(() => {
    doneFetchActions(getPlantas()).then((resp: [propsPlantas]) => {
      setPlantas(resp);
    })
  }, [doneFetchActions])


  return (
    <div>
      <div className='d-flex justify-content-center pt-4'>
        <h4 className="text-center mb-4">
          {
            {
              [PATHS.REPORTES.CONSOLIDADO_CONDUCTOR]: "Consolidado de conductores",
              [PATHS.REPORTES.ESTRACTO_D_CONDUCTOR]: "Extracto diario de conductores"
            }[tipoReporte]
          }</h4>
      </div>
      <div className="row justify-content-center">
        <div className="col-lg-8">
          <form onSubmit={handleSubmit} className="row g-3 align-items-center">
            <div className="col-lg-3">
              <div className="form-floating mb-3">
                <select
                  className="form-select form-select-lg"
                  id="planta"
                  name="planta"
                  value={formValues.planta}
                  onChange={handleInputChange}
                >
                  <option value={0} >Seleccione una Planta</option>
                  {plantas.map(p => <option key={`plata_${p.id}`} value={p.id}>{p.nombre}</option>)}
                </select>
                <label htmlFor="planta">Plantas:</label>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="form-floating mb-3">
                <input
                  type="date"
                  id="fechaIni"
                  name="fechaIni"
                  value={formValues.fechaIni}
                  onChange={handleInputChange}
                  className="form-control form-control-lg"
                />
                <label htmlFor="fechaIni">Fecha inicial:</label>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="form-floating mb-3">
                <input
                  type="date"
                  id="fechaFin"
                  name="fechaFin"
                  value={formValues.fechaFin}
                  onChange={handleInputChange}
                  className="form-control form-control-lg"
                />
                <label htmlFor="fechaFin">Fecha Final:</label>
              </div>
            </div>
            <div className="col-lg-3 mt-0">
              <button type="submit" className="btn btn-lg btn-primary">
                <span className="icon-search"></span>
              </button>
            </div>
          </form>
        </div>
      </div>

      <Table dataTable={data} onChange={handleChangeTable} />
      <div className='d-flex justify-content-end gap-2'>
        <button onClick={() => downReport('csv')} className='btn btn-success'>CSV</button>
        <button onClick={() => downReport('pdf')} className='btn btn-danger'>PDF Simplificado</button>
        <button onClick={() => downReport('pdf-extendi')} className='btn btn-warning'>PDF Extendido</button>
      </div>
    </div>
  )
}